import type { PropertyValue } from './Common';

/**
 * An interface model for Screen
 */
export interface Screen {
  name: string;
  screenClass: string;
  properties?: {
    [key: string]: PropertyValue;
  };
}
